export default "__VITE_ASSET__CNARTxtO__"